import { render, staticRenderFns } from "./PackageListAddNew.vue?vue&type=template&id=43a27f9d"
import script from "./PackageListAddNew.vue?vue&type=script&lang=js"
export * from "./PackageListAddNew.vue?vue&type=script&lang=js"
import style0 from "./PackageListAddNew.vue?vue&type=style&index=0&id=43a27f9d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports